import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import EmailActivation from "../../authentication/EmailActivation";
import { fetchUserAction } from "../../../redux/actions/user/userAction";
import { connect } from 'react-redux'

export const UserSettings = (props) => {

    useEffect(() => {
        if (Object.keys(props.user).length === 0) {
            props.fetchUser()
        }
    }, [props]);

    return (
        <>
            {Object.keys(props.user).length === 0 ? (
                ""
            ) : props.user.is_email && props.user.is_email ? (
                <Navigate replace to="/user/dashboard" />
            ) : (
                <Routes>
                    <Route path="/email-activation" element={<EmailActivation />} />
                </Routes>
            )}
        </>
    )
}

const mapStateToProps = (state) => {
    const user = state.user.user;
    const is_user = state.user.is_user;
    return {
        user: user,
        is_user: is_user,
    };
};

const mapDispatchToProps = (dispatch, state) => {
    return {
        fetchUser: () => dispatch(fetchUserAction()),
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(UserSettings)
